/* eslint-disable @typescript-eslint/no-explicit-any */

import { BASE_SHADING, DESIGN_MODES, IMAGERY_PROVIDER,
	NREL_BASE_DERATE_FACTOR, NREL_DC_TO_AC_DERATE_FACTOR, PUERTI_RICO_STATE_CODE,
} from './constants';

function debounce(func: (...args: any[]) => void, timeout = 50) {
	let debouncedFunc: NodeJS.Timeout | null = null;

	return function (this: ThisParameterType<typeof func>, ...args: any[]) {
		if (!debouncedFunc) {
			debouncedFunc = setTimeout(() => {
				func.apply(this, args);
			}, timeout);
		} else {
			clearTimeout(debouncedFunc);
			debouncedFunc = setTimeout(() => {
				func.apply(this, args);
			}, timeout);
		}
	};
}

function mapNumber(mapNum: number, inMin: number, inMax: number, outMin: number, outMax: number) {
	return Math.round((mapNum - inMin) * (outMax - outMin) / (inMax - inMin) + outMin);
}

function createApiUrl(url: string) {
	if (process.env.NODE_ENV === 'production') {
		return `${process.env.REACT_APP_PRODUCTION_API_URL}${url}`;
	}
	return `${process.env.REACT_APP_LOCAL_API_URL}${url}`;
}

function numberInRange(num: number, min: number, max: number): boolean {
	return num >= min && num <= max;
}

function suggestExactAllingmentBasedUponMaxPanelSizes(items: number[], weightLimit: number) {
	const n = items.length;
	console.log('weightLimit', weightLimit);
	const dp = new Array(n + 1).fill(0).map(() => new Array(weightLimit + 1).fill(0));
	for (let i = 1; i <= n; i++) {
		for (let j = 1; j <= weightLimit; j++) {
			if (items[i - 1] <= j) {
				dp[i][j] = Math.max(dp[i - 1][j], items[i - 1] + dp[i - 1][j - items[i - 1]]);
			} else {
				dp[i][j] = dp[i - 1][j];
			}
		}
	}

	const selectedItems = [];
	let i = n;
	let j = weightLimit;
	while (i > 0 && j > 0) {
		if (dp[i][j] !== dp[i - 1][j]) {
			selectedItems.push(i - 1);
			j -= items[i - 1];
		}
		i--;
	}
	// console.log('selectedItems',selectedItems);
	return selectedItems;
}

function suggestAllingmentBasedUponMaxPanelSizes(panels: number[], kwhLimit: number, kwhLimitPLusFityPerc: number) {
	console.log('kwhLimit', kwhLimit, '50', kwhLimitPLusFityPerc);
	let wattsLeft = kwhLimit, i = 0, wattsLeftForFIftyPerc = kwhLimitPLusFityPerc;
	const selectedPanelsIndex = [];
	const unselectedPanelsIndex = [];
	while (wattsLeftForFIftyPerc > 0 && i < panels.length) {
		// console.log('p',panels[i]);
		if (wattsLeft > 0)
			selectedPanelsIndex.push(i);
		else
			unselectedPanelsIndex.push(i);
		wattsLeftForFIftyPerc -= panels[i];
		wattsLeft -= panels[i];
		i++;
	}

	// console.log('selectedItems',selectedPanelsIndex,unselectedPanelsIndex);
	return {
		selectedPanelsIndex,
		unselectedPanelsIndex
	};
}

function getAnnualEnergyFromBillAmount(billPerMonth: number, unitPrice: number) {
	// get it from api instead of assuming
	//cents
	// billPerMonth = billPerMonth
	const electricUnitPrice = unitPrice || 26.5;
	const totalMegaKilloWatt = (billPerMonth * 100) / electricUnitPrice;
	// yearly
	return Math.floor(totalMegaKilloWatt * 12);
}

function getBillAmountFromAnnualEnergy(annualEnergy: number, unitPrice: number) {

	const electricUnitPrice = unitPrice || 26.5;
	annualEnergy /= 12;
	const billPerMonth = (annualEnergy * electricUnitPrice) / 100;
	return Math.floor(billPerMonth);
}

function setDiff<T>(a: Set<T>, b: Set<T>) {
	const diff: T[] = [];
	const sml = a.size < b.size ? a : b;
	const lrg = a.size < b.size ? b : a;

	lrg.forEach(i => {
		!sml.has(i) && diff.push(i);
	});

	return diff;

}

function makePanelKeyFromCoordinate(coord: Coordinate) {
	return `${coord.latitude},${coord.longitude}`;
}

function makeRasterPanelKeyFromTopLeftCorner(coord: number[]) {
	return `${coord[0]},${coord[1]}`;
}

const getToken = (name: string) => {
	const token = sessionStorage.getItem(`SOLAR_QUOTE_EMBED_${name}`);
	return token;
};

function generateQueryParams(params: any, prefix = ''): string {
	const query: string[] = [];

	for (const key in params) {
		if (params[key] === undefined || params[key] === null) continue;

		const value = params[key];
		const paramKey = prefix ? `${prefix}[${key}]` : key;

		// --- nested object ---
		if (typeof value === 'object' && !Array.isArray(value)) {
			const nested = generateQueryParams(value, paramKey);

			// remove leading '?'
			if (nested.startsWith('?')) {
				query.push(nested.slice(1));
			} else {
				query.push(nested);
			}
		}

		// --- array ---
		else if (Array.isArray(value)) {
			value.forEach((item) => {
				query.push(`${paramKey}[]=${encodeURIComponent(item)}`);
			});
		}

		// --- primitive ---
		else {
			query.push(`${paramKey}=${encodeURIComponent(value)}`);
		}
	}

	return query.length ? `?${query.join('&')}` : '';
}

function areEqual(arr1: any[], arr2: any[]) {
	if (arr1.length !== arr2.length)
		return false;
	for (let i = 0; i < arr1.length; i++) {
		if (!Object.is(arr1[i], arr2[i]))
			return false;
	}
	return true;
}

// sasti copy of how react memo works
function shallowMemoize<T extends (...args: any[]) => any>(func: T): T {
	let previousArgs: Parameters<T> | undefined;
	let previousResults: ReturnType<T> | undefined;

	return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
		if (!previousArgs) {
			previousResults = func.apply(this, args as any);
			previousArgs = args;
		} else if (!areEqual(previousArgs, args)) {
			previousResults = func.apply(this, args as any);
			previousArgs = args;
		}
		return previousResults;
	} as T;
}

function getDeratedValue(value: number, derate: number ) {
	return (value * (100 - derate)) / 100;
}

function getPercentage(val: number, percent: number) {
	return val * (percent / 100);
}

function removeFalsyValueFromObj(obj: { [key: string]: any }) {
	if (!obj) return obj;
	const newObj: Partial<typeof obj> = {};
	Object.keys(obj).forEach(k => {
		const v = obj[k];
		if (v) newObj[k] = obj[k];
	});
	return newObj;
}

function convertObjValsToNum(obj: { [key: string]: string }) {
	if (!obj) return obj;
	const newObj: { [key: string]: number } = {};
	Object.keys(obj).forEach(k => {
		const v = obj[k];
		if (v) newObj[k] = +obj[k];
	});
	return newObj;
}

function calculateOffsetPercentage(energy: number, billEnergy: number) {
	return Math.round((energy/billEnergy)*100);
}

// Modes that produce the default (Sunroof-based) roof layout. IN_HOUSE_SIMULATION
// uses the same layout as DEFAULT (only its energy computation differs), so it is
// grouped here for layout/imagery/UI decisions.
const DEFAULT_MODES = [
	DESIGN_MODES.DEFAULT,
	DESIGN_MODES.DEFAULT_MANUAL,
	DESIGN_MODES.IN_HOUSE_SIMULATION,
	DESIGN_MODES.IN_HOUSE_SIMULATION_MANUAL,
];

function isModeDefault(designMode: DESIGN_MODES | DesignModes) {
	return DEFAULT_MODES.includes(designMode as DESIGN_MODES);
}

const IN_HOUSE_SIMULATION_MODES = [
	DESIGN_MODES.IN_HOUSE_SIMULATION,
	DESIGN_MODES.IN_HOUSE_SIMULATION_MANUAL,
];

function isInHouseSimulationMode(designMode: DESIGN_MODES | DesignModes) {
	return IN_HOUSE_SIMULATION_MODES.includes(designMode as DESIGN_MODES);
}

const SUNROOF_ENERGY_MODES = [
	DESIGN_MODES.DEFAULT,
	DESIGN_MODES.DEFAULT_MANUAL,
];

const IMAGERY_SOURCE_LABEL = {
	[IMAGERY_PROVIDER.SUNROOF]: 'Google Maps HD',
	[IMAGERY_PROVIDER.GOOGLE_STATIC]: 'Google Maps',
	[IMAGERY_PROVIDER.NEARMAP]: 'Nearmap',
	[IMAGERY_PROVIDER.EAGLEVIEW]: 'EagleView',
};

enum SOLAR_DATA_SOURCE_KEY {
  IN_HOUSE = 'nrel_nsrdb_with_3d_analysis',
  GOOGLE = 'sunroof',
  GOOGLE_AND_NREL = 'sunroof_nrel',
  NREL = 'nrel',
}

const SOLAR_DATA_SOURCE_LABEL = {
	[SOLAR_DATA_SOURCE_KEY.IN_HOUSE]: 'NREL NSRDB (TMY) with 3D shade analysis',
	[SOLAR_DATA_SOURCE_KEY.GOOGLE]: 'Google Solar API',
	[SOLAR_DATA_SOURCE_KEY.GOOGLE_AND_NREL]: 'Google Solar API & NREL PVWatts',
	[SOLAR_DATA_SOURCE_KEY.NREL]: 'NREL PVWatts',
};

export type SolarDataSource = { key: SOLAR_DATA_SOURCE_KEY, label: string };

function getSolarDataSourceKey(
	designMode: DesignModes,
	opts: { hasFlatFacet?: boolean } = {},
): SOLAR_DATA_SOURCE_KEY {
	if (isInHouseSimulationMode(designMode))
		return SOLAR_DATA_SOURCE_KEY.IN_HOUSE;

	if (SUNROOF_ENERGY_MODES.includes(designMode as DESIGN_MODES)) {
		// flat / ground mount facets are always simulated through nrel
		return opts.hasFlatFacet
			? SOLAR_DATA_SOURCE_KEY.GOOGLE_AND_NREL
			: SOLAR_DATA_SOURCE_KEY.GOOGLE;
	}

	return SOLAR_DATA_SOURCE_KEY.NREL;
}

function getSolarDataSource(
	designMode: DesignModes,
	opts: { hasFlatFacet?: boolean } = {},
): SolarDataSource {
	const key = getSolarDataSourceKey(designMode, opts);
	return { key, label: SOLAR_DATA_SOURCE_LABEL[key] };
}

function getImagerySourceLabel(imagerySource: IMAGERY_PROVIDER | ImagerySource) {
	return IMAGERY_SOURCE_LABEL[imagerySource as IMAGERY_PROVIDER] ?? imagerySource;
}

// we use dc energy to calculate energy of panels in non default modes
// hence we use the below factor to change from dc to ac energy
function decideDerateBasedUponMode(designMode: DESIGN_MODES | DesignModes, energyDerateRate: number, stateCode: string | null) {
	let modeEnergyRate = energyDerateRate;

	if (!isModeDefault(designMode)) {
		modeEnergyRate = NREL_DC_TO_AC_DERATE_FACTOR + NREL_BASE_DERATE_FACTOR;

		if (stateCode === PUERTI_RICO_STATE_CODE && energyDerateRate) {
			modeEnergyRate += Number(energyDerateRate);
		}
	}

	return modeEnergyRate;
}

function isReduxPersistedDataEmpty() {
	const reduxPersistedData = sessionStorage.getItem('persist:root'); // Check 'persist:root' key
	console.log('reduc Persesited Data', reduxPersistedData);
	if (!reduxPersistedData) {
		console.log('No Redux persisted data found.');
		return true; // Data is missing
	}

	try {
		const parsedData = JSON.parse(reduxPersistedData);
		if (Object.keys(parsedData).length === 0) {
			console.log('Redux persisted data is empty.');
			return true; // Data exists but is empty
		}
	} catch (error) {
		console.log('Invalid Redux persisted data.');
		return true; // Data is invalid JSON
	}

	console.log('Redux persisted data exists.');
	return false; // Data exists and is valid
}

function getPanelPxScale(groundMetersPerPixel: number) {
	return groundMetersPerPixel * 10;
}

function convertMetricToFeet(val: number, unit: 'm' | 'm2' = 'm', precision = 2){
	if(unit === 'm2')
		return +(val * 10.7639).toFixed(precision);

	return +(val * 3.28084).toFixed(precision);
}

function convertFeetToMetric(val: number, unit: 'm' | 'm2' = 'm', precision = 2) {
	if (unit === 'm2') {
		return +(val / 10.7639).toFixed(precision); // ft² → m²
	}
	return +(val / 3.28084).toFixed(precision); // ft → m
}

function roundOffNumber(val: number, precision = 0) {
	const factor = 10 ** precision;
	return Math.round(val * factor) / factor;
}

function convertMetricToLinearFeet(valInMeters: number) {
	// Conversion factor from meters to feet
	const feetPerMeter = 3.28084;

	// Calculate total feet
	const totalFeet = valInMeters * feetPerMeter;

	// Get the whole number of feet
	let feet = Math.floor(totalFeet);

	// Get the decimal part and convert to inches
	const inches = (totalFeet - feet) * 12;

	// Round the inches to a reasonable precision (e.g., one decimal place)
	// const roundedInches = Math.round(inches * 10) / 10;

	// Round the inches to the nearest whole number
	let roundedInches = Math.round(inches);

	// Handle the case where inches round up to 12
	if (roundedInches >= 12) {
		feet += 1;
		roundedInches = 0;
	}

	// Return the formatted string
	return `${feet}' ${roundedInches}"`;
}

const findIntersection = (arr1: any[], arr2: any[]): any[] => arr1.filter((elem: any) => arr2.includes(elem));

const convertShading = (shadingVal: number) => {
	if(shadingVal == 14.08) return 'None';
	if(shadingVal == 15.85) return 'Low';
	if(shadingVal == 20.28) return 'Medium';
	if(shadingVal == 24.76) return 'High';
	return (shadingVal-BASE_SHADING).toString();
};

export {
	debounce,
	mapNumber,
	createApiUrl,
	numberInRange,
	suggestExactAllingmentBasedUponMaxPanelSizes,
	suggestAllingmentBasedUponMaxPanelSizes,
	makeRasterPanelKeyFromTopLeftCorner,
	getAnnualEnergyFromBillAmount,
	setDiff,
	makePanelKeyFromCoordinate,
	getToken,
	generateQueryParams,
	shallowMemoize,
	getDeratedValue,
	getPercentage,
	getBillAmountFromAnnualEnergy,
	removeFalsyValueFromObj,
	convertObjValsToNum,
	calculateOffsetPercentage,
	isModeDefault,
	isInHouseSimulationMode,
	getSolarDataSource,
	SOLAR_DATA_SOURCE_KEY,
	getImagerySourceLabel,
	decideDerateBasedUponMode,
	isReduxPersistedDataEmpty,
	getPanelPxScale,
	convertMetricToFeet,
	convertMetricToLinearFeet,
	findIntersection,
	convertShading,
	convertFeetToMetric,
	roundOffNumber
};
